import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import './style.css';
import {
  Button, Card, CardHeader, CardTitle, CardBody, CardFooter,
  Form, Input, InputGroupAddon, InputGroupText, InputGroup,
  Container, Col, Row
} from "reactstrap";
import logo from "assets/img/logo-login.png";
import settings from "settings";
import rotas from "services/rotas";

const Redefinir = ({ location }) => {
  const [novaSenha,  setNovaSenha]  = useState("");
  const [confirma,   setConfirma]   = useState("");
  const [loading,    setLoading]    = useState(false);
  const [validando,  setValidando]  = useState(true);
  const [tokenValido, setTokenValido] = useState(false);
  const [concluido,  setConcluido]  = useState(false);
  const [msg,        setMsg]        = useState({ tipo: "", texto: "" });

  const token = new URLSearchParams(location?.search).get("token") || "";

  useEffect(() => {
    document.body.classList.toggle("login-page");
    return () => {
      document.body.classList.toggle("login-page");
    };
  }, []);

  useEffect(() => {
    if (!token) {
      setMsg({ tipo: "erro", texto: "Link inválido. Solicite uma nova redefinição de senha." });
      setValidando(false);
      return;
    }
    const url = settings.url + rotas.senhaValidar + "?token=" + encodeURIComponent(token);
    axios.get(url)
      .then((ret) => {
        if (ret.data.success === "S") {
          setTokenValido(true);
        } else {
          setMsg({ tipo: "erro", texto: ret.data.msg });
        }
      })
      .catch(() => setMsg({ tipo: "erro", texto: "Erro ao validar o link." }))
      .finally(() => setValidando(false));
  }, [token]);

  const redefinir = async (e) => {
    e.preventDefault();
    setMsg({ tipo: "", texto: "" });

    if (!novaSenha || !confirma) {
      setMsg({ tipo: "erro", texto: "Preencha todos os campos." });
      return;
    }
    if (novaSenha !== confirma) {
      setMsg({ tipo: "erro", texto: "As senhas não conferem." });
      return;
    }

    setLoading(true);
    try {
      const url = settings.url + rotas.senhaRedefinir;
      const ret = await axios.post(url, { token, nova_senha: novaSenha, confirma });
      if (ret.data.success === "S") {
        setConcluido(true);
        setMsg({ tipo: "ok", texto: ret.data.msg });
      } else {
        setMsg({ tipo: "erro", texto: ret.data.msg });
      }
    } catch {
      setMsg({ tipo: "erro", texto: "Erro ao conectar com o servidor." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <Container>
        <Row>
          <Col className="ml-auto mr-auto" lg="4" md="6">
            <Form className="form" onSubmit={redefinir}>
              <Card className="card-login text-center">
                <CardHeader className="text-center p-0">
                  <div className="logo">
                    <div className="logo-img">
                      <img src={logo} alt="WebGestor" style={{ width: "50%" }} />
                    </div>
                  </div>
                  <CardTitle tag="h4">Redefinir senha</CardTitle>
                </CardHeader>

                <CardBody>
                  {validando && (
                    <p style={{ color: "#888", fontSize: "13px" }}>Validando link...</p>
                  )}

                  {!validando && tokenValido && !concluido && (
                    <>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="nc-icon nc-key-25" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          placeholder="Nova senha"
                          type="password"
                          autoComplete="off"
                          value={novaSenha}
                          onChange={(e) => setNovaSenha(e.target.value)}
                        />
                      </InputGroup>

                      <InputGroup className="mb-0">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="nc-icon nc-key-25" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          placeholder="Confirme a nova senha"
                          type="password"
                          autoComplete="off"
                          value={confirma}
                          onChange={(e) => setConfirma(e.target.value)}
                        />
                      </InputGroup>
                    </>
                  )}

                  {msg.texto && (
                    <p style={{
                      fontSize: "13px",
                      color: msg.tipo === "ok" ? "#27ae60" : "#e74c3c",
                      fontWeight: 600,
                      margin: "12px 0 0"
                    }}>
                      {msg.texto}
                    </p>
                  )}
                </CardBody>

                <CardFooter>
                  {!validando && tokenValido && !concluido && (
                    <Button
                      className="btn-round"
                      color="primary"
                      type="submit"
                      disabled={loading}
                    >
                      {loading ? "Salvando..." : "Alterar senha"}
                    </Button>
                  )}
                  <br />
                  <Link
                    to="/painelwebgestor/auth/login"
                    style={{ fontSize: "12px", color: "#888", marginTop: "8px", display: "inline-block" }}
                  >
                    {concluido ? "Ir para o login" : "Voltar ao login"}
                  </Link>
                </CardFooter>
              </Card>
            </Form>
          </Col>
        </Row>
      </Container>
      <div
        className="full-page-background"
        style={{ backgroundImage: `url(${require("assets/img/bg/webgestor_login_bg.jpg")})` }}
      />
    </div>
  );
};

export default Redefinir;
